module.exports = __webpack_public_path__ + "static/media/catalyst-bg-0.09bb3305.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/catalyst-bg-0.svg
// module id = 1121
// module chunks = 0